<template>
  <el-dialog
    :modal-append-to-body="false"
    :visible.sync="visible"
    :title="$t('Integrations_Optimove_SyncDialog_Title')"
    width="400px"
    center
  >
    <el-row type="flex" justify="center">
      <el-button type="primary" :loading="syncLoading" @click="startSync">
        {{ $t('Integrations_Optimove_SyncDialog_StartSync') }}
      </el-button>
    </el-row>
  </el-dialog>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  name: 'OptimoveSyncAttrsDialog',

  data() {
    return {
      visible: false,
      syncLoading: false
    }
  },

  methods: {
    show() {
      this.visible = true
    },

    startSync() {
      this.syncLoading = true
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `integrations/optimove/${this.$attrs.model.id}/sync-attrs`
        })
      )
        .then(({ data }) => {
          this.syncLoading = false
          this.visible = false
          this.$router.push(
            projectRoute({
              name: 'TaskHistoryView',
              query: { id: data.id }
            })
          )
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
          this.syncLoading = false
          this.visible = false
        })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/optimove/OptimoveSyncAttrsDialog.vue